<template>
  <div>
    <tutorial-video v-if="stepToShow" :step="stepToShow" />
  </div>
</template>

<script>
import allSteps from '@last/core/src/tutorialSteps.js'

import TutorialVideo from '@/components/TutorialVideo.vue'

export default {
  name: 'Tutorial',
  computed: {
    stepToShow() {
      if (this.$route) {
        return Object.values(this.steps).find(step => {
          return step.route === this.$route.name && this.$route.query.showVideo
        })
      }
      return null
    },
    steps() {
      return allSteps.steps
    }
  },
  components: {
    TutorialVideo
  }
}
</script>
<style></style>
